<script setup lang="ts">
import type { Props } from '@/shared/ui/AppIcon/model/types/appIcon';

defineOptions({
  name: 'AppIcon',
});

const iconModules = import.meta.glob<{ default: Component }>(
  '@/shared/ui/Icons/**/*.vue',
);

const ICONS_PATH = '/src/shared/ui/Icons';

const IconPlaceholder = defineComponent({
  name: 'IconPlaceholder',
  render: () =>
    h('svg', { class: 'app-icon', width: 0, height: 0, 'aria-hidden': 'true' }),
});

const props: Props = withDefaults(defineProps<Props>(), {
  name: '',
  directory: '',
});

const component: ComputedRef<Component | null> = computed(() => {
  const dir = props.directory ? `${props.directory}/` : '';
  const loader = iconModules[`${ICONS_PATH}/${dir}${props.name}.vue`];
  return loader
    ? defineAsyncComponent({
        loader,
        loadingComponent: IconPlaceholder,
        delay: 0,
        suspensible: false,
      })
    : null;
});

const iconStyle: ComputedRef<Record<string, string> | undefined> = computed(() => {
  const style: Record<string, string> = {};
  if (props.width) style.width = props.width;
  if (props.height) style.height = props.height;
  if (props.minWidth) style.minWidth = props.minWidth;
  if (props.minHeight) style.minHeight = props.minHeight;
  return Object.keys(style).length ? style : undefined;
});
</script>

<template>
  <component :is="component" v-if="component" class="app-icon" :style="iconStyle" />
</template>

<style lang="less">
.app-icon {
  display: inline-flex;
  justify-content: center;
  flex-shrink: 0;
}
</style>
